<template>
  <div class="p-20">
{{posts}}
  </div>
</template>

<script>
export default {
  name: 'Api',
  data() {
    return {
      // Initialize "response"
      response: null,
      search_term:'',
      posts: [],
      apps: []
    }
  },
  computed: {
    filteredList() {
            return this.posts.results.filter((post) => {
                return post.data.title[0].text
                    .toLowerCase()
                    .includes(this.search_term.toLowerCase());
            });
        },
  },
  methods: {
    async getContent() {
      // Query the API and assign the response to "response"
      const response = await this.$prismic.client.getSingle('homepage')
      this.response = response
    },
    async getBlogPosts(){
        const posts = await this.$prismic.client.query(
        this.$prismic.predicate.at('document.type','blogpost')
        );
        this.posts = posts;
        console.log('got posts')
    },
    async getApps(){
        const apps = await this.$prismic.client.query(
        this.$prismic.predicate.at('document.type','app')
        );
        this.apps = apps;
        console.log('got apps')
    },
  },
  created() {
    // Call the API query method
    this.getBlogPosts()
    this.getApps()
    this.getContent()
  }
}
</script>